/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConsentEntity,
    ConsentEntityFromJSON,
    ConsentEntityFromJSONTyped,
    ConsentEntityToJSON,
} from './ConsentEntity';
import {
    ReadConsentOptOutEntity,
    ReadConsentOptOutEntityFromJSON,
    ReadConsentOptOutEntityFromJSONTyped,
    ReadConsentOptOutEntityToJSON,
} from './ReadConsentOptOutEntity';

/**
 * 
 * @export
 * @interface CardTypeConsentDTO
 */
export interface CardTypeConsentDTO {
    /**
     * 
     * @type {string}
     * @memberof CardTypeConsentDTO
     */
    cardTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof CardTypeConsentDTO
     */
    exportRestriction?: string;
    /**
     * 
     * @type {string}
     * @memberof CardTypeConsentDTO
     */
    sendPostToCarePrincipal?: string;
    /**
     * 
     * @type {string}
     * @memberof CardTypeConsentDTO
     */
    recurringCard?: string;
    /**
     * 
     * @type {Array<ConsentEntity>}
     * @memberof CardTypeConsentDTO
     */
    consents?: Array<ConsentEntity>;
    /**
     * 
     * @type {ReadConsentOptOutEntity}
     * @memberof CardTypeConsentDTO
     */
    readConsentOptOut?: ReadConsentOptOutEntity;
}

export function CardTypeConsentDTOFromJSON(json: any): CardTypeConsentDTO {
    return CardTypeConsentDTOFromJSONTyped(json, false);
}

export function CardTypeConsentDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardTypeConsentDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cardTypeId': !exists(json, 'cardTypeId') ? undefined : json['cardTypeId'],
        'exportRestriction': !exists(json, 'exportRestriction') ? undefined : json['exportRestriction'],
        'sendPostToCarePrincipal': !exists(json, 'sendPostToCarePrincipal') ? undefined : json['sendPostToCarePrincipal'],
        'recurringCard': !exists(json, 'recurringCard') ? undefined : json['recurringCard'],
        'consents': !exists(json, 'consents') ? undefined : ((json['consents'] as Array<any>).map(ConsentEntityFromJSON)),
        'readConsentOptOut': !exists(json, 'readConsentOptOut') ? undefined : ReadConsentOptOutEntityFromJSON(json['readConsentOptOut']),
    };
}

export function CardTypeConsentDTOToJSON(value?: CardTypeConsentDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cardTypeId': value.cardTypeId,
        'exportRestriction': value.exportRestriction,
        'sendPostToCarePrincipal': value.sendPostToCarePrincipal,
        'recurringCard': value.recurringCard,
        'consents': value.consents === undefined ? undefined : ((value.consents as Array<any>).map(ConsentEntityToJSON)),
        'readConsentOptOut': ReadConsentOptOutEntityToJSON(value.readConsentOptOut),
    };
}

